import { useState } from 'react';
import { useGame } from '../state/store';
import { SEAL_COLORS } from '../game/content';
import { SeatEmblem } from './Icon';
import { MenuBackdrop } from './MenuBackdrop';
import { Seg, TIMER_OPTIONS } from './Seg';
import { ResolutionsSeg } from './Home';

export function Lobby() {
  const room = useGame((s) => s.room);
  const you = useGame((s) => s.you);
  const lobby = useGame((s) => s.lobby);
  const leave = useGame((s) => s.leave);
  const status = useGame((s) => s.status);
  const [copied, setCopied] = useState(false);
  if (!room) {
    return (
      <main className="lobby">
        <MenuBackdrop centered />
        <div className="frame lobby-card">
          <h2>{status === 'reconnecting' ? 'Reconnecting…' : 'Finding the room…'}</h2>
          <button onClick={leave}>Back</button>
        </div>
      </main>
    );
  }
  const isHost = you?.seat != null && room.hostSeat === you.seat;
  const link = `${location.origin}/room/${room.code}`;
  return (
    <main className="lobby">
      <MenuBackdrop centered />
      <section className="frame lobby-card">
        <h2 className="lobby-title">
          Room <span className="code">{room.code}</span>
        </h2>
        <div className="invite">
          <input readOnly value={link} aria-label="Invite link" onFocus={(e) => e.currentTarget.select()} />
          <button
            className="gilt-btn small"
            onClick={async () => {
              await navigator.clipboard?.writeText(link);
              setCopied(true);
              setTimeout(() => setCopied(false), 1500);
            }}
          >
            {copied ? 'Copied!' : 'Copy invite link'}
          </button>
        </div>
        <h3 className="section-title">
          Seats {room.seats.length}/{room.settings.maxPlayers}
        </h3>
        <ul className="seat-list">
          {room.seats.map((s) => (
            <li key={s.seat} style={{ '--seal': SEAL_COLORS[s.seat] } as React.CSSProperties}>
              <SeatEmblem seat={s.seat} size={30} />
              <span className="name">
                {s.name}
                {s.seat === you?.seat && ' (you)'}
                {room.hostSeat === s.seat && ' · host'}
              </span>
              <span className={`flag ${s.connected ? '' : 'warn'}`}>{s.kind === 'bot' ? 'bot' : s.connected ? 'ready' : 'offline'}</span>
              {isHost && s.seat !== you?.seat && (
                <button className="small" onClick={() => lobby({ op: 'removeSeat', seat: s.seat })}>
                  Remove
                </button>
              )}
            </li>
          ))}
          {Array.from({ length: room.settings.maxPlayers - room.seats.length }, (_, i) => (
            <li key={`empty${i}`} className="empty">
              <span>Waiting for a player…</span>
              {isHost && (
                <button className="small" onClick={() => lobby({ op: 'addBot' })}>
                  + Add Clerk-bot
                </button>
              )}
            </li>
          ))}
        </ul>
        {you?.seat == null && <p className="hint">You are spectating this room.</p>}
        <div className="lobby-settings">
          <Seg
            label="Seats"
            readOnly={!isHost}
            value={room.settings.maxPlayers}
            onChange={(n) => lobby({ op: 'settings', settings: { maxPlayers: n } })}
            options={[2, 3, 4, 5].map((n) => ({ value: n, label: n, disabled: n < room.seats.length }))}
          />
          <Seg label="Turn timer" readOnly={!isHost} value={room.settings.timer} onChange={(t) => lobby({ op: 'settings', settings: { timer: t } })} options={[...TIMER_OPTIONS]} />
          <ResolutionsSeg readOnly={!isHost} value={room.settings.resolutions !== false} onChange={(on) => lobby({ op: 'settings', settings: { resolutions: on } })} />
        </div>
        {isHost ? (
          <div className="host-controls">
            <button className="gilt-btn primary wide" disabled={room.seats.length < 2} onClick={() => lobby({ op: 'start' })}>
              Open the Ministry
            </button>
          </div>
        ) : (
          <p className="hint">Waiting for the host to start the game…</p>
        )}
        <button className="link" onClick={leave}>
          Leave room
        </button>
      </section>
    </main>
  );
}
